export const calculateGrandTotal = ({
  bookingSidebar,
  extraBedPrice,
  totaldays,
}) => {
  return bookingSidebar.reduce((acc, plan) => {
    const roomTotal =
      plan.type !== "addonservice" ? plan.totalRate * plan.selectedRooms : 0;
    const extraBedCharge = plan.extraBed
      ? Object.values(plan.extraBed).reduce(
          (sum, isExtraBed) =>
            sum + (isExtraBed ? extraBedPrice * totaldays : 0),
          0
        )
      : 0;
    const addOnServiceTotal =
      plan.type === "addonservice" ? plan.servicePrice : 0;
    return acc + roomTotal + extraBedCharge + addOnServiceTotal;
  }, 0);
};
